import personalRecommendations from '@/js/services/api/personalRecommendations';

export default {
  namespaced: true,
  state: {
    hasRecommendations: false,
  },
  mutations: {
    /**
     * Устанавливаем флаг рекомендаций пользователя
     * @param state
     * @param payload {boolean}
     */
    setRecommendations(state, payload) {
      state.hasRecommendations = payload;
    },
  },
  actions: {
    /**
     * Получаем данные о рекомендациях для пользователя
     * @param  commit
     * @param isbn
     */
    async getRecommendations({ commit }) {
      await personalRecommendations({ recoType: 'reco_kk' })
        .then(({ list }) => {
          commit('setRecommendations', !!list.length);
        })
        .catch((error) => {
          Promise.reject(error);
        });
    },
  },
};
